<template>
  <path
    d="M21 3.00018H3C1.9 3.00018 1 3.90018 1 5.00018V19.0002C1 20.1002 1.9 21.0002 3 21.0002H21C22.1 21.0002 23 20.1002 23 19.0002V5.00018C23 3.90018 22.1 3.00018 21 3.00018ZM20 19.0002H13C12.45 19.0002 12 18.5502 12 18.0002V14.0002C12 13.4502 12.45 13.0002 13 13.0002H20C20.55 13.0002 21 13.4502 21 14.0002V18.0002C21 18.5502 20.55 19.0002 20 19.0002Z"
  />
</template>
